import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div className="page-hero flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6" data-testid={testid}>
      <div className="min-w-0">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-100"><span className="nexus-page-mark" aria-hidden="true"/>{title}</h1>
        {subtitle && <p className="text-sm text-slate-400 mt-1">{subtitle}</p>}
      </div>
      {children && <div className="page-header-actions flex min-w-0 flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, accent = "amber", testid, onClick, to, ariaLabel }) {
  const map = {
    amber: "text-amber-400 bg-amber-500/10",
    red: "text-red-400 bg-red-500/10",
    emerald: "text-emerald-400 bg-emerald-500/10",
    blue: "text-blue-400 bg-blue-500/10",
    purple: "text-purple-400 bg-purple-500/10",
  };
  const content = (
    <>
      <div className="flex items-start justify-between">
        <div>
          <div className="caption-mono">{label}</div>
          <div className="font-heading text-2xl font-bold text-slate-100 mt-2">{value}</div>
          {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
        </div>
        {Icon && <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${map[accent]}`}><Icon className="h-5 w-5" /></div>}
      </div>
    </>
  );
  const interactiveClass = "metric-card metric-card--interactive mb-card mb-card-hover p-5 animate-fade-up w-full text-left cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/80 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 active:scale-[.99]";
  if (to) {
    return <Link to={to} aria-label={ariaLabel || `Open ${label}`} className={interactiveClass} data-accent={accent} data-testid={testid}>{content}</Link>;
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} aria-label={ariaLabel || `Open ${label}`}
        className={interactiveClass}
        data-accent={accent}
        data-testid={testid}>
        {content}
      </button>
    );
  }
  return <div className="metric-card mb-card mb-card-hover p-5 animate-fade-up" data-accent={accent} data-testid={testid}>{content}</div>;
}

export function Spinner({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-500 gap-2">
      <Loader2 className="h-5 w-5 animate-spin" /> {label}
    </div>
  );
}

export function Empty({ label = "Nothing here yet." }) {
  return <div className="mb-card p-12 text-center text-slate-500 text-sm">{label}</div>;
}
